module.exports = __webpack_public_path__ + "static/Griffon-0148b59c7814c46d16621232537e9f11.jpg";